<template>
  <div class="container">
    <h3 class="title">W celu organizacji wizyty domowej dla członka rodziny,<br/>
      innego niż dziecko do lat 15tu, prosimy o telefoniczny kontakt<br/>
      z centrum alarmowym pod numerem:</h3>
    <div class="btn-group">
      <a class="btn" :style="{ background: $color }" :href="`tel:${$phone}`">{{$phone}}</a>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: "StepMedicalOtherPerson",
  methods: {
    ...mapMutations(['setUserData', 'setAssistanceStep']),
    btnHandler (VisitFor) {
      this.setUserData({ VisitFor })
      this.setAssistanceStep('medicalSymptoms')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/assistance_steps/StepMedicalOtherPerson.vue